import { isValid, parseISO } from 'date-fns';

export default function createValidDate(date: string) {
  if (isNaN(Date.parse(date))) {
    return;
  }

  const parsedISO = parseISO(date);

  if (isValid(parsedISO)) {
    return parsedISO;
  }

  return new Date(date);
}
